<template>
  <div class="mc-order-dashboard" :key="key">
    <b-row>
      <DeliveryStatusWidget
        @showDetail="handleShowWidgetModal"
        @deliveryOrderType="deliveryOrderType = $event"
      />
      <DeliveryAchievementWidget
        @showDetail="handleShowWidgetModal"
        @changeDateRange="handleChangeAchievementRange"
      />
      <TopOnTimeVendorDelivery />
      <TopCustomerWidget />
      <TopVendorRejectedDelivery v-if="hasVendorAccess" />
      <TopVendorDeliveryLate v-if="hasVendorAccess" />
    </b-row>
    
    <ModalWidget
      v-if="currentStatus"
      :achievementDateRange="achievementDateRange"
      :status="currentStatus"
      :deliveryOrderType="deliveryOrderType"
      @close="handleCloseWidgetModal"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DeliveryAchievementWidget from '../components/DeliveryAchievementWidget.vue'
import DeliveryStatusWidget from '../components/DeliveryStatusWidget'
import TopCustomerWidget from '../components/TopCustomerWidget'
import TopVendorRejectedDelivery from '../components/TopVendorRejectedDelivery'
import TopVendorDeliveryLate from '../components/TopVendorDeliveryLate'
import TopOnTimeVendorDelivery from '../components/TopOnTimeVendorDelivery'
import ModalWidget from '../components/ModalWidget.vue'

export default {
  components: {
    DeliveryStatusWidget,
    DeliveryAchievementWidget,
    ModalWidget,
    TopCustomerWidget,
    TopVendorDeliveryLate,
    TopVendorRejectedDelivery,
    TopOnTimeVendorDelivery,
  },
  data() {
    return {
      key: 1,
      currentStatus: '',
      deliveryOrderType: '',
      achievementDateRange: []
    }
  },
  computed: {
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
    }),
    hasVendorAccess() {
      return this.hasAccessAll(['vms:create', 'vms:read', 'vms:update', 'vms:delete']) || false
    },
  },
  watch: {
    '$i18n.locale': function () {
      this.key += 1
    }
  },
  methods: {
    handleShowWidgetModal(status) {
      this.currentStatus = status
    },
    handleCloseWidgetModal() {
      this.currentStatus = ''
    },
    handleChangeAchievementRange(dateRange) {
      this.achievementDateRange = dateRange
    },
  },
}
</script>
